var _circle, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhase4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 93,
    viewBox: "0 0 108 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#D11C1C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_204_2440)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 88,
    height: 73,
    rx: 5,
    fill: "url(#paint0_linear_204_2440)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20.5,
    width: 87,
    height: 72,
    rx: 4.5,
    stroke: "url(#paint1_linear_204_2440)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 62.1888C67.3138 62.1888 70 59.4831 70 56.1452C70 52.8074 67.3138 50.1017 64 50.1017C60.6862 50.1017 58 52.8074 58 56.1452C58 59.4831 60.6862 62.1888 64 62.1888Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2448 52.9127L77.0494 47.573L80 44.0581L76 40.029L72.5294 43.0165L67.1156 40.7739L65.8706 36H61.962L60.6982 40.8371L55.4088 43.083L52 40.029L48 44.0581L50.9067 47.6618L48.745 53.0153L44 54.1307V58.1597L48.8022 59.4803L51.0315 64.8071L48 68.2324L52 72.2614L55.5823 69.3208L60.794 71.4804L62 76.2904H66L67.209 71.4822L72.5102 69.2708C73.3938 69.907 76 72.2614 76 72.2614L80 68.2324L77.0318 64.7057L79.2278 59.3644L83.9998 58.1138L84 54.1307L79.2448 52.9127Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_204_2440",
    x: -5,
    y: -5,
    width: 138,
    height: 123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_204_2440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_204_2440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_2440",
    x1: -9.17563,
    y1: -49.6818,
    x2: 61.8865,
    y2: -36.3225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBFB",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_204_2440",
    x1: 106.029,
    y1: 69.5515,
    x2: 40.0421,
    y2: 64.8705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase4);
export default __webpack_public_path__ + "static/media/Phase 4.c2fd2fe31355fa64e8e92255cb39beba.svg";
export { ForwardRef as ReactComponent };